<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Póliza
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="dialogForm = true">Nuevo</v-btn>
            <modalComponent :cargar="dialogForm" :seleccionado="seleccionado" :tituloFormulario="tituloFormulario"
                :listaGeneral="listaGeneral" :listaEstado="listaEstadoModal"
                :listaTipoPoliza="listaTipoPolizaModal">
            </modalComponent>            
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="3">
                        <v-autocomplete label="Contratante *" color="textbox" v-model="contratanteFiltro"
                            :items="listaGeneral.contratante" item-text="contratante" item-value="idContratante"
                            @change="listar" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="aseguradoraFiltro"
                            :items="listaGeneral.aseguradora" item-text="aseguradora" item-value="idAseguradora"
                            @change="listar" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="seguroFiltro"
                            :items="listaGeneral.seguro" item-text="seguro" item-value="idSeguro" @change="listar"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete label="Estado *" color="textbox" v-model="estadoFiltro"
                            :items="listaGeneral.estado" item-text="nombre_estado" item-value="id_estado"
                            @change="listar" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="buscar" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="buscar" :headers="listaGeneral.cabecera" :items="listaGeneral.detalle"
                            class="elevation-3">
                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editarItem(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="buscar"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        components: {
            modalComponent: () => import('@/components/constructor/ModalPolizaComponent.vue')
        },
        data: () => ({
            ProgressBar : true,
            buscar: '',
            dialogForm: false,
            seleccionado : {},
            //Listas
            listaGeneral : [],
            //Filtros
            contratanteFiltro : null,
            aseguradoraFiltro : null,
            seguroFiltro : null,
            estadoFiltro : '1',
        }),
        mounted () {
            this.cargaGeneral();
        },
        watch: {
            listaGeneral(){
                this.contratanteFiltro = this.listaGeneral.contratante[0].idContratante;
                this.listar('l');
            }
        },
        computed: {
            tituloFormulario () {
                return  (this.seleccionado.idPoliza == "0" || this.seleccionado.idPoliza == null)  ? 'Nueva Póliza' : 'Editar Póliza'
            },
            listaEstadoModal(){
                var listadoEstadoModal = this.listaGeneral.estado;
                if(this.listaGeneral.estado){
                    listadoEstadoModal =  this.listaGeneral.estado.filter(estado => {
                            return estado.visualiza.toLowerCase().includes('true');
                        });
                    this.seleccionado.idEstado = (this.seleccionado.idPoliza == null ) ? '1' :  this.seleccionado.idEstado;
                    this.seleccionado.idPoliza = (this.seleccionado.idPoliza == null ) ? '0' :  this.seleccionado.idPoliza;
                }
                return listadoEstadoModal;
            },
            listaTipoPolizaModal(){
                var listaTipoPolizaModal = this.listaGeneral.tipoPoliza;
                if(this.listaGeneral.tipoPoliza){
                    listaTipoPolizaModal =  this.listaGeneral.tipoPoliza.filter(tipoPoliza => {
                            return tipoPoliza.visualiza.toLowerCase().includes('true');
                        });
                }
                return listaTipoPolizaModal;
            }
        },
        methods: {
            submit () {
                this.$validator.validateAll()
            },
            cargaGeneral(){
                axios.post(`${BASE_URI}administrador/poliza/cargaGeneral`,{
                    opcion :  'L'
                })
                .then((respuesta)=>{
                    if(respuesta.status == '200' && respuesta.data.existeError!=null){
                        if(!respuesta.data.existeError)
                            this.listaGeneral = respuesta.data.data;
                        else mensajesAlerta(respuesta.data.mensaje, 'E');
                    }else mensajesAlerta(mensajeEstandar.errorPeticion, "E");
                })
                .catch(function(er){
                    mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                }).finally(() => this.ProgressBar = false);
            },
            editarItem (item) {
                this.seleccionado = Object.assign({}, item),
                this.seleccionado.porcComision=parseInt(this.seleccionado.porcComision);
                this.seleccionado.porcBeneficios=parseInt(this.seleccionado.porcBeneficios);
                this.dialogForm = true
            },
            cerrarFormulario () {
                this.dialogForm = false
                this.seleccionado = {}
            },
            listar(e){
                if(!_.isUndefined(e)){
                    var error = 'E';

                    this.listaGeneral.detalle= [];
                    const contratante = this.contratanteFiltro;
                    const aseguradora = this.aseguradoraFiltro;
                    const seguro = this.seguroFiltro;
                    const estado = this.estadoFiltro;
                    axios.post(`${BASE_URI}administrador/poliza/listar`,{
                        opcion :  'L',
                        idContratante: contratante,
                        idAseguradora: aseguradora,
                        idSeguro: seguro,
                        idEstado: estado,
                    })
                    .then((r)=>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }

                            this.listaGeneral.detalle = r.data.data;
                    })
                    .catch((er)=>{
                        mensajesAlerta(er, error);
                    });
                }
            },
            insertarActualizar(_opcion){
                axios.post(`${BASE_URI}administrador/poliza/mantenimiento`,{
                    opcion :  _opcion,
                    poliza : this.seleccionado
                })
                .then((r)=>{
                    if(r.status != '200') throw mensajeEstandar.errorPeticion;
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        mensajeAlertaTiempo(r.data.mensaje,"S");
                        this.cerrarFormulario();
                        this.listar('L');
                })
                .catch(function(er){
                    mensajesAlerta(er, "E");
                });
            }
        },
        provide() {
            return {
                insertarActualizar: this.insertarActualizar,
                cerrarFormulario: this.cerrarFormulario
            }
        },
    }
</script>